import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "customer-quote",
      path: "quotes/:quoteID",
      props: true,
      meta: {
        icon: "quote",
        title: (route) =>
          i18n.global.tc(
            store.getters.isCustomer() ? "Quote" : "Customer Quote"
          ),
        crumbs: ["customer-quotes"],
      },
      component: () => import("pages/customer/quotes/Quote"),
    },
    {
      name: "customer-quotes",
      path: "quotes",
      props: true,
      meta: {
        icon: "quotes",
        title: (route) =>
          i18n.global.tc(
            store.getters.isCustomer() ? "Quote" : "Customer Quote",
            100
          ),
        widget: "CustomerQuotes",
      },
      component: () => import("pages/customer/Home"),
    },
  ],

  dialogs: [],
};
